import React from 'react';
import "./Meteo.css";
import AutoIcon from "../../controls/AutoIcon.mjs";
import TextLabel from "../../controls/TextLabel.mjs";
import {Glob as G} from "../../libs/Glob.mjs";
import appLib from "../../libs/appLib.mjs";
import MeteoCanvas from "./MeteoCanvas.mjs";

const Meteo = class extends React.Component {
	constructor(props) {
		super(props);
		const qtdays = props.qtdays ? parseInt(props.qtdays) : 2;
		this.state = {
			qtdays: qtdays,
			data: props.data,
			lang: G.getLanguage(),
			langLong: G.getLanguageLong()
		}
		if ( props.title) {
			if ( typeof props.title === 'string' ) {
				this.state.title = props.title;
			} else {
				this.state.title = 'Weather forecasts';
			}
		}
		this.uid = G.generateUid('Meteo');
		this.load = this.load.bind(this);
		this.update = this.update.bind(this);
	}
	componentDidMount() {
		G.register("Prefs", l=>{
			if ( l?.language !== this.state.lang ) this.setState({
				lang: l?.language,
				langLong: G.getLanguageLong( l?.language )
			});
		}, this.uid);
		G.register("appPulse", this.update, this.uid);
		setTimeout( this.load );
	}
	componentWillUnmount() {
		G.deregister(this.uid);
	}
	update() {
		const now = new Date();
		const h = now.getHours();
		const m = now.getMinutes();
		const tm = Math.round(m / 10);
		const ns = {};
		if ( m !== this.state.minUpdate ) ns.minUpdate = m;
		if ( tm !== this.state.tenMinsUpdate ) ns.tenMinsUpdate = tm;
		if ( h !== this.state.hourUpdate ) ns.hourUpdate = h;
		if ( Object.keys(ns).length ) this.setState( ns, ()=>{
			if ( this.state.data && h !== this.state.dataHour ) setTimeout( this.load )
		});
	}
	async load() {
		let data = false;
		try {
			data =  await appLib.data('meteo');
		} catch (e) {
			console.error('Meteo - load',e);
			setTimeout( this.load, 5000 );
			return;
		}
		const out = [];
		const now = new Date();
		now.setHours(now.getHours() -2);
		const qtDays = Math.min( data.meteo.length, this.state.qtdays );
		const maxDate = new Date( now.getTime() + (qtDays -1) * 86400000 );
		for ( let i = 0; i < qtDays; i++ ) {
			const di = data.meteo[i].day;
			out[i] = { day: di, hours: [] };
			const min = { temp: data.meteo[i].hours[0].temp, app: data.meteo[i].hours[0].app };
			const max = { temp: data.meteo[i].hours[0].temp, app: data.meteo[i].hours[0].app };
			data.meteo[i].hours.forEach(day => {
				if ( day.temp < min.temp ) min.temp = day.temp;
				if ( day.app < min.app ) min.app = day.app;
				if ( day.temp > max.temp ) max.temp = day.temp;
				if ( day.app > max.app ) max.app = day.app;
				const d = new Date( di + ' '+ String(day.hour).padStart(2, '0')+':00:00' );
				if ( d >= now && d <= maxDate ) out[i].hours.push(day);
			});
			out[i].minTemp = min.temp;
			out[i].maxTemp = max.temp;
			out[i].minApp = min.app;
			out[i].maxApp = max.app;
		}
		const rdata = G.clone(out);
		rdata[0].hours = rdata[0].hours.slice(1);
		this.setState({ data: rdata, gdata: out, dataHour: (new Date()).getHours() });
	}
	render() {
		if ( typeof this.state.data === 'undefined' ) return null;
		const dts = (this.state.data||[]);
		return(
			<div
				className={"Meteo"}
				id={this.uid}
			>
				{ this.state.title && (
					<h2>
						<AutoIcon value={"meteo"} />
						<TextLabel value={this.state.title} />
					</h2>
				)}
				{ this.props.graph ? (
					<MeteoCanvas
						hour={ this.state.dataHour }
						data={ this.state.gdata }
					/>
				) : (
					<table>
						<thead>
						<tr>
							<th />
							<th>
								<TextLabel value={"Hours"} />
							</th>
							<th>
								<span className={"mobile-only"}>
									<TextLabel value={"Temp"} />
								</span>
								<span className={"no-mobile"}>
									<TextLabel value={"Temperature"} />
								</span>
							</th>
							<th>
								<span className={"mobile-only"}>
									<TextLabel value={"Perc"} />
								</span>
								<span className={"no-mobile"}>
									<TextLabel value={"Perceived"} />
								</span>
							</th>
							<th>
								<TextLabel value={"Rain"} />
							</th>
							<th>
								<span className={"mobile-only"}>
									<TextLabel value={"Hum"} />
								</span>
								<span className={"no-mobile"}>
									<TextLabel value={"Humidity"} />
								</span>
							</th>
							<th>
								<TextLabel value={"Wind"} />
							</th>
						</tr>
						</thead>
						<tbody>
						{ dts.map( day =>
							day.hours.map( (h,i) => (
								<tr key={day.day+i} className={ i === 0 ? 'datechanged' : ''}>
									<td className={"giorno"}>
										{ i === 0 && (new Date( day.day + ' '+ String(h.hour).padStart(2, '0')+':00:00' )).toLocaleString(this.state.langLong, {weekday: 'short', day: 'numeric'}) }
									</td>
									<td className={"ore"}>
										{h.hour}
									</td>
									<td className={"temp"+( h.temp === day.minTemp ? " min" : (h.temp === day.maxTemp ? ' max' : '')) }>
										{h.temp}
									</td>
									<td className={"temp apptemp"+( h.app === day.minApp ? " min" : (h.app === day.maxApp ? ' max' : ''))}>
										{h.app}
									</td>
									<td className={"rain"}>
										{h.pp ? h.pp : ''}
									</td>
									<td className={"humidity"}>
										{h.hum ? h.hum : ''}
									</td>
									<td className={"wind"}>
										{h.wind ? h.wind : ''}
									</td>
								</tr>
							))
						)}
						<tr>
							<td colSpan={7} className={"pt-3 text-center"}>
								<small>
									[<a href="https://open-meteo.com/" target={"_blank"} rel="noreferrer">Weather data by Open-Meteo.com</a>]
								</small>
							</td>
						</tr>
						</tbody>
					</table>
				)}
			</div>
		)
	}
}

export default Meteo;